import { homeProduct } from 'global-config';
import { Casino, SportsHome } from '../lazy_components';

const PRODUCTS_MAP = {
  sports: {
    component: SportsHome,
  },
  casino: {
    component: Casino,
    property: 'lobbyTag',
  },
};

export default () => {
  const [productName, tag] = homeProduct.split('::');
  const { component, property } = PRODUCTS_MAP[productName] || { component: SportsHome };

  return {
    component,
    props: {
      [property]: tag,
    },
  };
};
